import React from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import { ADD, CLOSE_FRIENDS, LIST, CREATE_ITEM } from "constants/index"
import { NAVIGATE_TO_CREATE_ITEM_PAGE } from "constants/events"
import { useAppSelector } from "appRedux/hooks"
import AddIcon from "components/atoms/_icons/AddIcon"
import CTA from "components/atoms/CTA"
import EmptyState from "components/atoms/EmptyState"
import withRoleBasedPermission from "components/HOCs/withRoleBasedPermission"
import withPremiumPermission from "components/HOCs/withPremiumPermission"

type WishListViewEmptyStateProps = {
  showAddNewItemButton?: boolean
}

export default function WishListViewEmptyState(props: WishListViewEmptyStateProps) {
  const { showAddNewItemButton = true } = props

  const wishListState = useAppSelector((state) => state.wishList)

  const { t } = useTranslation()

  function handleAddItem(event: React.MouseEvent<HTMLButtonElement>) {
    document.dispatchEvent(new CustomEvent(NAVIGATE_TO_CREATE_ITEM_PAGE))
  }

  return (
    <EmptyState>
      {showAddNewItemButton && <ButtonWrapperWithRoleBasedPermission
          resource={LIST}
          action={ADD}
      >
          <CTAWithPremiumPermission
              feature={CREATE_ITEM}
              constraint={wishListState.listInfo?.privacy === CLOSE_FRIENDS}
              constraintType={CLOSE_FRIENDS}
              variant="contained"
              endIcon={<AddIcon/>}
              onClick={handleAddItem}
          >
            {t("items.newItem")}
          </CTAWithPremiumPermission>
      </ButtonWrapperWithRoleBasedPermission>}
    </EmptyState>
  )
}

const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "140px",
  marginTop: "12px",
  stroke: "#FFFFFF",

  "& span": {
    marginLeft: "-8px",
    marginRight: "8px"
  }
}))

const ButtonWrapperWithRoleBasedPermission = withRoleBasedPermission(ButtonWrapper)
const CTAWithPremiumPermission = withPremiumPermission(CTA)
